<template>
  <div class="loading-identity">
    <div class="data-computing">
      <div class="data-computing-text">
        <div class="data-computing-title">
          <div class="data-computing-title-gif"></div>
          <h2 class="data-computing-title-text">Conferindo dados...</h2>
        </div>
        <p class="data-computing-body">Buscando dado médico para agilizar seu atendimento.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { removeQueryParamsFromUrl } from '@/utils/helpers/removeQueryParamsFromUrl';

export default {
  name: 'LoadingMedicalIdentity',
  async created() {
    const medicalOrders = this.getUploadedMedicalOrders();
    await this.searchOcrMedicalIdentification({
      documents: [removeQueryParamsFromUrl(medicalOrders[0]?.data?.documentUrl)],
    });
    const response = await this.pullingMedicalIdentification();
    if (
      !this.isSuccessStatus(response) ||
      !this.hasOnlyOneCRM(response) ||
      !this.hasAllCRMData(response)
    ) {
      const crm = response?.crms[0];
      this.SET_PROFESSIONALIDENTIFICATION({
        council: crm?.org?.toUpperCase(),
        registryNumber: crm?.number,
        state: crm?.state?.toUpperCase(),
      });
      return this.$router.push({ name: 'professional-identification', params: { response } });
    } else {
      const crm = response?.crms[0];
      const mdmDataProfessional = await this.searchMdmProfessional({
        council: crm?.org?.toUpperCase(),
        value: crm.number,
        uf: crm?.state?.toUpperCase(),
      });
      if (!mdmDataProfessional) {
        return this.$router.push({ name: 'questions' });
      } else {
        return this.$router.push({ name: 'check-professional-identification' });
      }
    }
  },
  methods: {
    ...mapActions([
      'searchMdmProfessional',
      'searchOcrMedicalIdentification',
      'pullingMedicalIdentification',
    ]),
    ...mapGetters({
      getUploadedMedicalOrders: 'getUploadedMedicalOrders',
    }),
    ...mapMutations(['SET_PROFESSIONALIDENTIFICATION']),
    isSuccessStatus(response) {
      return response?.status === 'OCR_SUCCESS';
    },
    hasOnlyOneCRM(response) {
      return response?.crms?.length === 1;
    },
    hasAllCRMData(response) {
      return response?.crms[0].org && response?.crms[0].number && response.crms[0].state;
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-identity {
  // background-color: #F7F7F8;
  width: 100%;
  align-items: center;
  padding: 0px;
  display: flex;
  flex-direction: column;
}
.data-computing {
  background: #ffffff;
  width: 328px;
  height: 192px;
  margin-top: 32px;
  padding: 16px 16px 32px 16px;
  gap: 24px;
  border-radius: 4px;
  box-shadow: 0px 24px 56px 0px #16161614;
  box-shadow: 0px 12px 12px 0px #1616160a;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.data-computing-text {
  width: 290px;
  height: 144px;
  gap: 8px;
}
.data-computing-title {
  width: 290px;
  height: 88px;
  gap: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.data-computing-title-gif {
  background: url(../../assets/img/loader-small-white.gif);
  background-size: cover;
  width: 51px;
  height: 32px;
}
.data-computing-title-text {
  width: 290px;
  height: 24px;
  font-family: 'Dasa sans', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  color: #343a40;
}
.data-computing-body {
  width: 290px;
  height: 48px;
  font-family: 'Dasa sans', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  color: #343a40;
}
</style>
